export default __webpack_public_path__ + "static/car_4_door-4ac6423ec172dee94cfbecfa1b133827.svg";